


export let apkVersionToString=(apkVersion)=>{
   

   if(apkVersion ==0){
    return 'Web'
   }else if(apkVersion < 10){
        return apkVersion
   }else if(apkVersion > 10){
    return apkVersion/10000
}
}